import React, { Component } from 'react';
import { Modal, Header, Button, Icon } from 'semantic-ui-react';

class ConfirmationModal extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
  }
  openModal() {
    this.setState({ isOpen: true });
  }
  closeModal() {
    this.setState({ isOpen: false });
  }
  render() {
    return (
      <Modal
        trigger={<Button icon onClick={() => this.openModal()}><Icon name="trash" size="large" /></Button>}
        size="small"
        open={this.state.isOpen}
      >
        <Header content="Are you sure you want to delete this row?" />
        <Modal.Actions>
          <Button onClick={() => this.closeModal()}>Cancel</Button>
          <Button
            onClick={() => {
              this.props.onClick();
              this.closeModal();
            }}
            negative
          >Delete</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/modules/ConfirmationModal/component.js